import { SorterResult } from "antd/es/table/interface";
import { SurveyType } from "../types/surveyType";

export const getSortStr = (sorter: SorterResult<SurveyType> | Array<SorterResult<SurveyType>>) =>
  Array.isArray(sorter) || !sorter?.order
    ? undefined
    : `${sorter.columnKey},${sorter.order.substring(0, sorter.order.length - 3)}`;
